import { render, staticRenderFns } from "./NumberLine.vue?vue&type=template&id=1904aea3&scoped=true&"
import script from "./NumberLine.vue?vue&type=script&lang=js&"
export * from "./NumberLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1904aea3",
  null
  
)

export default component.exports